import { Nft } from "@/api/nfts/types";
import { Button } from "@/app/(components)/Basic/Button";
import { Modal } from "@/app/(components)/Basic/Modal";
import React, { useState } from "react";
import ArrowRightIcon from "@/assets/icons/arrow-right.svg";
import { Tabs } from "@/app/(components)/Basic/Tabs";
import AttachNftsList from "./AttachNftsList";

export interface Props {
  isOpen: boolean;
  onClose: () => void;
  createdNfts: Nft[];
  ownedNfts: Nft[];
  initialAttachedNftId: string | undefined;
  onChange: (attachedNftId: string) => void;
}
const FeedAttachNft = ({
  isOpen,
  onClose,
  createdNfts,
  ownedNfts,
  initialAttachedNftId,
  onChange,
}: Props) => {
  const [attachedNftId, setAttachedNftId] = useState<string | undefined>(
    initialAttachedNftId,
  );

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className="lg:p-8 lg:pr-6 md:w-[500px] w-full"
    >
      <h3 className="text-body-2 font-semibold mb-2">Attach NFT</h3>
      <Tabs
        contentClassName="pt-0 mt-6 mb-6"
        initialTab={
          createdNfts.length > 0
            ? "portfolio"
            : ownedNfts.length > 0
              ? "owned"
              : ""
        }
        showNavigation={createdNfts.length > 0 && ownedNfts.length > 0}
        tabs={[
          {
            id: "portfolio",
            label: "Portfolio",
            content: (
              <AttachNftsList
                idPrefix={"portfolio"}
                subtitle={"Select the NFT you created to attach."}
                nfts={createdNfts}
                selected={attachedNftId}
                setSelected={setAttachedNftId}
              />
            ),
          },
          {
            id: "owned",
            label: "Owned",
            content: (
              <AttachNftsList
                idPrefix={"owned"}
                subtitle={"Select the NFT you own to attach."}
                nfts={ownedNfts}
                selected={attachedNftId}
                setSelected={setAttachedNftId}
              />
            ),
          },
        ]}
      />
      <div className="text-center pt-2">
        <Button type="button" className="mr-2" onClick={onClose}>
          Cancel
        </Button>
        <Button
          type="button"
          endIcon={<ArrowRightIcon className="w-5 mr-1.5" />}
          onClick={() => {
            if (attachedNftId) {
              onChange(attachedNftId);
            }
            setAttachedNftId(undefined);
            onClose();
          }}
        >
          Attach
        </Button>
      </div>
    </Modal>
  );
};

export default React.memo(FeedAttachNft);
